<div id="radios">
  
  <input id="option1" name="options" type="radio" value="1" (click)="testSlider($event.target.value)">
  <label id="1" for="option1">1</label>

  <input id="option2" name="options" type="radio" value="2" (click)="testSlider($event.target.value)">
  <label id="2" for="option2">2</label>

  <input id="option3" name="options" type="radio" value="3" (click)="testSlider($event.target.value)">
  <label id="3" for="option3">3</label>

  <input id="option4" name="options" type="radio" value="4" (click)="testSlider($event.target.value)">
  <label id="4" for="option4">4</label>

  <input id="option5" name="options" type="radio" value="5" (click)="testSlider($event.target.value)">
  <label id="5" for="option5">5</label>

</div>